//STOP TIMES
import stopData from "./stopTimesData.js";
const stopTimes = stopData();
//ANIMATION TITLES
import titleData from "./textBoxNameData.js";
const titles = titleData();

import touchPointsData from "./touchPoints";
const touchPoints = touchPointsData();

import animationIndicator from "./animationIndicatorData";

import animationPositionData from "./animationPosition";
const animationPosition = animationPositionData();
//MASKS

import maskData from "./maskData.js";
const masks = maskData();

import selectedAnimationsData from "./macroAnimationSelectionData.js";
let selectedAnimations = selectedAnimationsData();

export default function() {
  return macroAnimations;
}

let macroAnimations = [
  {
    id: "powerOutage",
    name: titles.zoneOne,
    position: animationPosition.zoneOne,
    width: "19.5%",
    height: "19.2%",
    animation: selectedAnimations.zoneOne,
    ref: "buildingOneAnimation",
    animationIndicatorPosition: animationIndicator.zoneOne,
    touchPoints: touchPoints.zoneOne,
    animationButton: {
      name: titles.zoneOne,
      position: { left: 7, bottom: 42 },
      transition: "left",
      voiceOver: "smart-energy-vo-1.mp3"
    },
    stopTimes: stopTimes.zoneOne,
    mask: masks.zoneOne,
    productsInAnimationIds: [0, 2, 3, 5, 6]
  },
  {
    id: "EnergyBuilding",
    name: titles.zoneTwo,
    textBoxPosition:
      "Avoid energy shortages and reduce carbon footprint by getting an accurate picture of energy supply and demand.",
    position: animationPosition.zoneTwo,
    width: "27%",
    height: "21.9%",
    animation: selectedAnimations.zoneTwo,
    ref: "EnergyBuildingAnimation",
    animationIndicatorPosition: animationIndicator.zoneTwo,
    touchPoints: touchPoints.zoneTwo,
    animationButton: {
      name: titles.zoneTwo,
      position: { left: 10, bottom: 53 },
      transition: "left",
      voiceOver: "energy-efficiency-vo-1.mp3"
    },
    stopTimes: stopTimes.zoneTwo,
    mask: masks.zoneTwo,
    productsInAnimationIds: [0, 2, 5, 6]
  },
  {
    id: "maritime",
    name: titles.zoneEleven,
    position: animationPosition.zoneEleven,
    width: "46.5%",
    height: "63.25%",
    animation: selectedAnimations.zoneEleven,
    ref: "maritimeAnimation",
    animationIndicatorPosition: animationIndicator.zoneEleven,
    touchPoints: touchPoints.zoneEleven,
    animationButton: {
      name: titles.zoneEleven,
      position: { left: 20, bottom: 35 },
      transition: "left",
      voiceOver: "smart-shipping-vo-1.mp3"
    },
    stopTimes: stopTimes.zoneEleven,
    mask: masks.zoneEleven,
    productsInAnimationIds: [0, 1, 2, 3, 5, 6, 7]
  },
  {
    id: "smartTransportation",
    name: titles.zoneThree,
    position: animationPosition.zoneThree,
    width: "27%",
    height: "28.2%",
    animation: selectedAnimations.zoneThree,
    ref: "smartTransportationInfrastructure",
    animationIndicatorPosition: animationIndicator.zoneThree,
    touchPoints: touchPoints.zoneThree,
    animationButton: {
      name: titles.zoneThree,
      position: { left: 25, bottom: 50 },
      transition: "left",
      voiceOver: "emergency-response-vo-1.mp3"
    },
    stopTimes: stopTimes.zoneThree,
    mask: masks.zoneThree,
    productsInAnimationIds: [0, 2, 3, 5, 6]
  },
  {
    // wellness
    id: "healthcareOne",
    name: titles.zoneEight,
    position: animationPosition.zoneEight,
    width: "39%",
    height: "31.5%",
    animation: selectedAnimations.zoneEight,
    ref: "healthCareOneAnimation",
    animationIndicatorPosition: animationIndicator.zoneEight,
    touchPoints: touchPoints.zoneEight,
    animationButton: {
      name: titles.zoneEight,
      position: { left: 38, bottom: 57 },
      transition: "left",
      voiceOver: "proactive-healthcare-vo-1.mp3"
    },
    stopTimes: stopTimes.zoneEight,
    mask: masks.zoneEight,
    productsInAnimationIds: [0, 2, 3, 5, 6]
  },
  {
    id: "proactivePublicTransport",
    name: titles.zoneFour,
    position: animationPosition.zoneFour,
    width: "34%",
    height: "20.9%",
    ref: "proactivePublicTransportAnimation",
    animation: selectedAnimations.zoneFour,
    animationIndicatorPosition: animationIndicator.zoneFour,
    touchPoints: touchPoints.zoneFour,
    animationButton: {
      name: titles.zoneFour,
      position: { left: 40, bottom: 40 },
      transition: "left",
      voiceOver: "proactive-transport-vo-1.mp3"
    },
    stopTimes: stopTimes.zoneFour,
    mask: masks.zoneFour,
    productsInAnimationIds: [0, 2, 5, 6]
  },

  {
    // equipment tracking
    id: "healthcareTwo",
    name: titles.zoneNine,
    position: animationPosition.zoneNine,
    width: "11.4%",
    height: "15%",
    animation: selectedAnimations.zoneNine,
    ref: "healthCareTwoAnimation",
    animationIndicatorPosition: animationIndicator.zoneNine,
    touchPoints: touchPoints.zoneNine,
    animationButton: {
      name: titles.zoneNine,
      position: { left: 47, bottom: 63 },
      transition: "right",
      voiceOver: "equipment-tracking-vo-1.mp3"
    },
    stopTimes: stopTimes.zoneNine,
    mask: masks.zoneNine,
    productsInAnimationIds: [0, 2, 5, 6]
  },
  {
    id: "Traffic",
    name: titles.zoneFive,
    position: animationPosition.zoneFive,
    width: "39.6%",
    height: "32%",
    animation: selectedAnimations.zoneFive,
    ref: "trafficAnimation",
    animationIndicatorPosition: animationIndicator.zoneFive,
    touchPoints: touchPoints.zoneFive,
    animationButton: {
      name: titles.zoneFive,
      position: { left: 65, bottom: 47 },
      transition: "right",
      voiceOver: "reduce-congestion-vo-1.mp3"
    },
    stopTimes: stopTimes.zoneFive,
    mask: masks.zoneFive,
    productsInAnimationIds: [0, 2, 5]
  },
  {
    id: "retail",
    name: titles.zoneTen,
    position: animationPosition.zoneTen,
    width: "18.6%",
    height: "16.8%",
    animation: selectedAnimations.zoneTen,
    ref: "retailAnimation",
    animationIndicatorPosition: animationIndicator.zoneTen,
    touchPoints: touchPoints.zoneTen,
    animationButton: {
      name: titles.zoneTen,
      position: { left: 60, bottom: 60 },
      transition: "right",
      voiceOver: "customer-loyalty-vo-1.mp3"
    },
    stopTimes: stopTimes.zoneTen,
    mask: masks.zoneTen,
    productsInAnimationIds: [0, 2, 5]
  },
  {
    id: "surveillance",
    name: titles.zoneTwelve,
    position: animationPosition.zoneTwelve,
    width: "33.6%",
    height: "19.6",
    animation: selectedAnimations.zoneTwelve,
    ref: "surveillanceAnimation",
    animationIndicatorPosition: animationIndicator.zoneTwelve,
    touchPoints: touchPoints.zoneTwelve,
    animationButton: {
      name: titles.zoneTwelve,
      position: { left: 75, bottom: 63 },
      transition: "right",
      voiceOver: "smart-surveillance-vo-1.mp3"
    },
    stopTimes: stopTimes.zoneTwelve,
    mask: masks.zoneTwelve,
    productsInAnimationIds: [0, 1, 2, 3, 4, 6, 7]
  },
  {
    id: "manufacturingOne",
    name: titles.zoneSix,
    position: animationPosition.zoneSix,
    width: "42.5%",
    height: "28%",
    animation: selectedAnimations.zoneSix,
    ref: "manufacturingOneAnimation",
    animationIndicatorPosition: animationIndicator.zoneSix,
    touchPoints: touchPoints.zoneSix,
    animationButton: {
      name: titles.zoneSix,
      position: { left: 82, bottom: 55 },
      transition: "right",
      voiceOver: "improved-supply-vo-1.mp3"
    },
    stopTimes: stopTimes.zoneSix,
    mask: masks.zoneSix,
    productsInAnimationIds: [0, 2, 6]
  },
  {
    id: "manufacturingTwo",
    name: titles.zoneSeven,
    position: animationPosition.zoneSeven,
    width: "13.5%",
    height: "8.9",
    animation: selectedAnimations.zoneSeven,
    ref: "manufacturingTwoAnimation",
    animationIndicatorPosition: animationIndicator.zoneSeven,
    touchPoints: touchPoints.zoneSeven,
    animationButton: {
      name: titles.zoneSeven,
      position: { left: 88, bottom: 47 },
      transition: "right",
      voiceOver: "proactive-maintenance-vo-1.mp3"
    },
    stopTimes: stopTimes.zoneSeven,
    mask: masks.zoneSeven,
    productsInAnimationIds: [0, 2, 5, 6]
  }
];
